import { render, staticRenderFns } from "./MVMTags.vue?vue&type=template&id=0baf82b4&"
import script from "./MVMTags.vue?vue&type=script&lang=js&"
export * from "./MVMTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports